import Vue from 'vue'
import i18n from '@ve-pro/ve/lang'

export const h = new Vue({
  i18n,
}).$createElement
